import { render } from "./doc-icon.vue?vue&type=template&id=4145fd38&ts=true"
import script from "./doc-icon.vue?vue&type=script&lang=ts"
export * from "./doc-icon.vue?vue&type=script&lang=ts"

import "./doc-icon.vue?vue&type=style&index=0&id=4145fd38&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__